import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'rosie-validation-error',
    template: `
    <ng-container *ngIf="show && translationKey">
     <div class="d-flex align-items-center gap-1 rosie-error-message" [ngClass]="customClass">
      <ng-container *ngIf="showErrorIcon">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8 15C9.85652 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85652 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1C6.14348 1 4.36301 1.7375 3.05025 3.05025C1.7375 4.36301 1 6.14348 1 8C1 9.85652 1.7375 11.637 3.05025 12.9497C4.36301 14.2625 6.14348 15 8 15ZM8 4C8.19891 4 8.38968 4.07902 8.53033 4.21967C8.67098 4.36032 8.75 4.55109 8.75 4.75V7.75C8.75 7.94891 8.67098 8.13968 8.53033 8.28033C8.38968 8.42098 8.19891 8.5 8 8.5C7.80109 8.5 7.61032 8.42098 7.46967 8.28033C7.32902 8.13968 7.25 7.94891 7.25 7.75V4.75C7.25 4.55109 7.32902 4.36032 7.46967 4.21967C7.61032 4.07902 7.80109 4 8 4ZM8 12C8.26522 12 8.51957 11.8946 8.70711 11.7071C8.89464 11.5196 9 11.2652 9 11C9 10.7348 8.89464 10.4804 8.70711 10.2929C8.51957 10.1054 8.26522 10 8 10C7.73478 10 7.48043 10.1054 7.29289 10.2929C7.10536 10.4804 7 10.7348 7 11C7 11.2652 7.10536 11.5196 7.29289 11.7071C7.48043 11.8946 7.73478 12 8 12Z" fill="#F43F5E"/>
        </svg>
      </ng-container>
      <div class="error-icon-placeholder" *ngIf="!showErrorIcon"></div>
      <span >{{ translationKey | translate:translationAttributes | capitalize }}</span>
     </div>
    </ng-container>
  `,
    styles: [`
  .error-icon-placeholder {
    width: 16px;
    height: 16px;
  }
  `],
    standalone: false
})
export class ValidationErrorComponent implements OnInit {
  @Input() show = false;
  @Input() translationKey = '';
  @Input() translationAttributes: any;
  @Input() customClass = '';
  @Input() showErrorIcon = false;


  constructor() {
  }

  ngOnInit(): void {
  }

}
